import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  plans: any[];
  private mwbuser: any = {};
  userSubject = new BehaviorSubject(this.me);
  loading = true;
  module?: string;
  constructor() {
    this.plans = [];
  }

  public set me(v: IHBSUSER) {
    this.mwbuser = v;
    // localStorage.setItem('mwbTools', JSON.stringify(this.mwbuser));
    this.userSubject.next(this.mwbuser);
  }
  public get me(): IHBSUSER {
    return this.mwbuser;
  }

  public set profile(v: IHBSUSER['profile']) {
    this.mwbuser.profile = v;
    // localStorage.setItem('mwbTools', JSON.stringify(this.mwbuser));
    this.userSubject.next(this.mwbuser);
  }

  /**
   * isLoggedIn
   */
  public get loggedIn(): boolean {
    // const user = localStorage.getItem('mwbTools');
    if (localStorage.getItem('aios')) {
      // this.mwbuser = JSON.parse(user);
      return true;
    }
    else {
      return false;
    }
  }
}
export interface IHBSUSER {
  portals?: IPOARTAL[];
  profile: {
    // id: number,
    email: string,
    verified_email: boolean,
    name: string,
    first_name?: string,
    last_name?: string,
    picture?: string,
    locale?: string,
    phone_number?: string
    date_format?: string,
    account_type: string,
    validity?: string,
    paid?: boolean,
    subscribe?:boolean,
  };
  subscriptionStatus?: 'active' | 'cancelled';
  plan?: {
    id: string;
    planName: string;
  };
}
export interface IPOARTAL {
  id?: string,
  name?: string,
  portal_id?: string,
  portal_domain?: string,
  isOnboarded?: number,
  isRemoving?: boolean
}
